export enum ClientPaymentTermsEnum {
    PaymentUpfront = 1,
    PaymentOnCompletion = 2,
    PaymentWithin30Days = 3,
}
